<template>
    <div class="modal_bg">
        <div class="modal_wrap modal_alert">
            <div class="close_btn_wrap">
                <button @click="fnEvent(false)">
                    <img src="@/assets/close_btn.png" class="img_con" alt="닫기버튼" />
                </button>
            </div>
            <div class="tit align_cnt">
                <h2>{{ title }}</h2>
            </div>
            <div class="modal_con_wrap">
                <div class="modal_con">{{ content }}</div>
            </div>
            <div class="btn_wrap align_right">
                <button v-if="no" class="btn btn_no" @click="fnEvent(false)">
                    {{ no }}
                </button>
                <button v-if="yes" class="btn btn_yes" @click="fnEvent(true)">
                    {{ yes }}
                </button>
                <button v-if="pageMove" class="btn btn_move_page" @click="pageMoving()">
                    {{ pageMove }}
                </button>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ModalEmits, ModalProps } from "@/interface/modal";

    const props = defineProps<ModalProps>();
    const emit = defineEmits<ModalEmits>();

    const fnEvent = (result: boolean) => {
        if (result === false) {
            emit("close", false);
        } else {
            emit("close", true);
        }
    };
    const pageMoving = () => {
        emit("pageMove");
    };
</script>
